export const getFormData = (query, file) => {
    const formData = new FormData();
    formData.append("operations", JSON.stringify({
            "query": query, 
            "variables": {"file" : null},
        })
    )
    if (file){
        formData.append("map", JSON.stringify({"0": ["variables.file"]}));
        formData.append("0", file);
    }
    
    return formData;
}